// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/export_logs/:log_id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementExportLogResult } from "./constants";
import type { ExportLogDetailsResponse } from "./types";

export const getExportLogsResult = reactQueryFetcherAdapter(
  engagementExportLogResult,
  (signal: AbortSignal, logId: string, appGroupId: string): Promise<ExportLogDetailsResponse> => {
    return fetch(`/engagement/export_logs/${logId}/${appGroupId}/`, "GET", {}, { signal });
  },
  null
);
